import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3f2ee754 = () => interopDefault(import('../../../pages/list.vue' /* webpackChunkName: "pages/list" */))
const _e86bb3ba = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _857e2d4e = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _c286481e = () => interopDefault(import('../../../pages/stable.vue' /* webpackChunkName: "pages/stable" */))
const _e2486dc8 = () => interopDefault(import('../../../pages/stable/_id.vue' /* webpackChunkName: "pages/stable/_id" */))
const _dce942c8 = () => interopDefault(import('../../../pages/stable/_id/admin.vue' /* webpackChunkName: "pages/stable/_id/admin" */))
const _b6cf297a = () => interopDefault(import('../../../pages/stable/_id/cleaner.vue' /* webpackChunkName: "pages/stable/_id/cleaner" */))
const _168ba67b = () => interopDefault(import('../../../pages/stable/_id/cleaner/_cid.vue' /* webpackChunkName: "pages/stable/_id/cleaner/_cid" */))
const _a097ae86 = () => interopDefault(import('../../../pages/stable/_id/cleaner/_cid/overview.vue' /* webpackChunkName: "pages/stable/_id/cleaner/_cid/overview" */))
const _71c857be = () => interopDefault(import('../../../pages/stable/_id/cleaner/_cid/service.vue' /* webpackChunkName: "pages/stable/_id/cleaner/_cid/service" */))
const _51e7d06a = () => interopDefault(import('../../../pages/stable/_id/control.vue' /* webpackChunkName: "pages/stable/_id/control" */))
const _4f86bbae = () => interopDefault(import('../../../pages/stable/_id/control/overview.vue' /* webpackChunkName: "pages/stable/_id/control/overview" */))
const _48229f10 = () => interopDefault(import('../../../pages/stable/_id/control/service.vue' /* webpackChunkName: "pages/stable/_id/control/service" */))
const _16cb2988 = () => interopDefault(import('../../../pages/stable/_id/overview.vue' /* webpackChunkName: "pages/stable/_id/overview" */))
const _188b3f26 = () => interopDefault(import('../../../pages/stable/_id/parameters.vue' /* webpackChunkName: "pages/stable/_id/parameters" */))
const _4533c5c2 = () => interopDefault(import('../../../pages/stable/_id/service.vue' /* webpackChunkName: "pages/stable/_id/service" */))
const _19bf1a4b = () => interopDefault(import('../../../pages/stable/_id/section/list.vue' /* webpackChunkName: "pages/stable/_id/section/list" */))
const _7b56b8d3 = () => interopDefault(import('../../../pages/stable/_id/section/_section.vue' /* webpackChunkName: "pages/stable/_id/section/_section" */))
const _1680f1f8 = () => interopDefault(import('../../../pages/stable/_id/section/_section/clima.vue' /* webpackChunkName: "pages/stable/_id/section/_section/clima" */))
const _63db798c = () => interopDefault(import('../../../pages/stable/_id/section/_section/configuration.vue' /* webpackChunkName: "pages/stable/_id/section/_section/configuration" */))
const _bb078d36 = () => interopDefault(import('../../../pages/stable/_id/section/_section/overview.vue' /* webpackChunkName: "pages/stable/_id/section/_section/overview" */))
const _0f89e30e = () => interopDefault(import('../../../pages/stable/_id/section/_section/service.vue' /* webpackChunkName: "pages/stable/_id/section/_section/service" */))
const _7bbaf9e8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/list",
    component: _3f2ee754,
    name: "list___en"
  }, {
    path: "/da/list",
    component: _3f2ee754,
    name: "list___da"
  }, {
    path: "/login",
    component: _e86bb3ba,
    name: "login___en"
  }, {
    path: "/da/login",
    component: _e86bb3ba,
    name: "login___da"
  }, {
    path: "/settings",
    component: _857e2d4e,
    name: "settings___en"
  }, {
    path: "/da/settings",
    component: _857e2d4e,
    name: "settings___da"
  }, {
    path: "/stable",
    component: _c286481e,
    children: [{
      path: ":id?",
      component: _e2486dc8,
      children: [{
        path: "admin",
        component: _dce942c8,
        name: "stable-id-admin___en"
      }, {
        path: "cleaner",
        component: _b6cf297a,
        children: [{
          path: ":cid?",
          component: _168ba67b,
          children: [{
            path: "overview",
            component: _a097ae86,
            name: "stable-id-cleaner-cid-overview___en"
          }, {
            path: "service",
            component: _71c857be,
            name: "stable-id-cleaner-cid-service___en"
          }]
        }]
      }, {
        path: "control",
        component: _51e7d06a,
        children: [{
          path: "overview",
          component: _4f86bbae,
          name: "stable-id-control-overview___en"
        }, {
          path: "service",
          component: _48229f10,
          name: "stable-id-control-service___en"
        }]
      }, {
        path: "overview",
        component: _16cb2988,
        name: "stable-id-overview___en"
      }, {
        path: "parameters",
        component: _188b3f26,
        name: "stable-id-parameters___en"
      }, {
        path: "service",
        component: _4533c5c2,
        name: "stable-id-service___en"
      }, {
        path: "section/list",
        component: _19bf1a4b,
        name: "stable-id-section-list___en"
      }, {
        path: "section/:section?",
        component: _7b56b8d3,
        children: [{
          path: "clima",
          component: _1680f1f8,
          name: "stable-id-section-section-clima___en"
        }, {
          path: "configuration",
          component: _63db798c,
          name: "stable-id-section-section-configuration___en"
        }, {
          path: "overview",
          component: _bb078d36,
          name: "stable-id-section-section-overview___en"
        }, {
          path: "service",
          component: _0f89e30e,
          name: "stable-id-section-section-service___en"
        }]
      }]
    }]
  }, {
    path: "/da/stable",
    component: _c286481e,
    children: [{
      path: ":id?",
      component: _e2486dc8,
      children: [{
        path: "admin",
        component: _dce942c8,
        name: "stable-id-admin___da"
      }, {
        path: "cleaner",
        component: _b6cf297a,
        children: [{
          path: ":cid?",
          component: _168ba67b,
          children: [{
            path: "overview",
            component: _a097ae86,
            name: "stable-id-cleaner-cid-overview___da"
          }, {
            path: "service",
            component: _71c857be,
            name: "stable-id-cleaner-cid-service___da"
          }]
        }]
      }, {
        path: "control",
        component: _51e7d06a,
        children: [{
          path: "overview",
          component: _4f86bbae,
          name: "stable-id-control-overview___da"
        }, {
          path: "service",
          component: _48229f10,
          name: "stable-id-control-service___da"
        }]
      }, {
        path: "overview",
        component: _16cb2988,
        name: "stable-id-overview___da"
      }, {
        path: "parameters",
        component: _188b3f26,
        name: "stable-id-parameters___da"
      }, {
        path: "service",
        component: _4533c5c2,
        name: "stable-id-service___da"
      }, {
        path: "section/list",
        component: _19bf1a4b,
        name: "stable-id-section-list___da"
      }, {
        path: "section/:section?",
        component: _7b56b8d3,
        children: [{
          path: "clima",
          component: _1680f1f8,
          name: "stable-id-section-section-clima___da"
        }, {
          path: "configuration",
          component: _63db798c,
          name: "stable-id-section-section-configuration___da"
        }, {
          path: "overview",
          component: _bb078d36,
          name: "stable-id-section-section-overview___da"
        }, {
          path: "service",
          component: _0f89e30e,
          name: "stable-id-section-section-service___da"
        }]
      }]
    }]
  }, {
    path: "/",
    component: _7bbaf9e8,
    name: "index___en"
  }, {
    path: "/da/",
    component: _7bbaf9e8,
    name: "index___da"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
